import React, { Component } from 'react';
import NavMenu from '../sidebar/navBar';
import SideMenu from '../sidebar/SidebarCustom';
import { connect } from 'react-redux';
import CitySuggestionCountry from "../Layout/CustomeCountrCitySuggestion";
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { CountryJson } from '../../../_constants/country';
import { RULESMESSAGE} from '../../../_constants/app.constants.js';
import { StateJson } from '../../../_constants/states';
import { withLocalize } from 'react-localize-redux';

import { notification } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { addAdminCityAction } from '../../../actions/Admin/CountryCityAction';
import $ from 'jquery';

import './../App.css';
let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    country: 'required',
    state: 'required',
    city: 'required',
    latitude:'required',
    longitude:'required'
    
};

let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();

class AdminAddCity extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            formData :{
               
            },
            requestServer:false,
            formArr:{}
        }

        this.addCityCountry = this.addCityCountry.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.cityCountryAdd && nextProps.cityCountryAdd.statusCode === 200 && this.state.requestServer) {
            notification.success({
                message: nextProps.cityCountryAdd.msg,
                className:'successNotification',
                duration: 3
            });

            this.setState({
                requestServer: false,
            })
            this.props.history.push({
                pathname: "/admin/view-city",
            });
        }
    }

    addCityCountry() {
        if (this.allValidate(false)) {
            let Obj = this.state.formData;
            Obj["coordinates"] = [Number(Obj.longitude),Number(Obj.latitude)]
            this.setState({
                requestServer:true
            })
            this.props.addAdminCityAction(Obj)
        }

        // if(this.state.dataSave){
        //     let Obj ={
        //         "country":this.state.Country,
        //         "state":this.state.State,
        //         "city":this.state.address,
        //         "coordinates":this.state.coordinate
        //     }
        //     this.setState({
        //         requestServer:true
        //     })
        //     this.props.props.addAdminCityAction(Obj)
        // }
    }

    handleChangeSelect = (name, value) => {
        let formData = this.state.formData;
        formData[name] = value,
            this.setState({
                formData: formData,
                currentCuntryCode: value.value,
                dataSave: false,
                countryError: false
            });
    }

    inputchange=(e)=>{
        e.preventDefault();
        let value = e.target.value;
        if(e.target.name == "city"){
            var array1 = value.split(' ');
            var newarray1 = [];
            for(var x = 0; x < array1.length; x++){
                newarray1.push(array1[x].charAt(0).toUpperCase()+array1[x].slice(1));
            }
            value =  newarray1.join(' ');
        }  
        if(e.target.name == "latitude" || e.target.name == "longitude"){
            // var reg = new RegExp('/^-?\d*\.?\d*$/');
            // console.log("jjj",reg.test(value))
            // // if(!Number(value)){
            // //     return true;
            // // }
        }         
       
        const {formData} = this.state
        formData[e.target.name]=value;
        this.setState({
            formData:formData
        })

    }
       
    allValidate(check) {
        if (!check) {
             formArr = []
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            console.log("formArr",formArr)
            this.setState({
                formArr
            });

        }
        if (validation.passes()) {
            return 1;
        }
    }


    render() {
        const { formData,formArr } = this.state;
        validation = new Validator(formData, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();
        console.log("StateJson[formData.Country.value]",StateJson,formData.country)
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Country<span>*</span></label>
                            <Select name="country" 
                                className="singup-control"
                                value={formData.country}
                                onChange={this.handleChangeSelect.bind(this, "country")}
                                options={CountryJson}
                                placeholder="Select Country"
                            />
                            <span style={styleData} className="error">{formArr.country && validation.errors.first('country')}</span>
                        </div>
                        <div className="col-md-6">
                            <label>State<span>*</span></label>
                            <Select name="state" 
                                className="singup-control"
                                value={formData.state}
                                onChange={this.handleChangeSelect.bind(this, "state")}
                                options={formData.country ? StateJson[formData.country.value]: []}
                                placeholder="Select State"
                            />
                            <span style={styleData} className="error">{formArr.state && validation.errors.first('state')}</span>
                            {this.state.countryError&&
                                <span className="requiredFiled">Please Select The State*</span>
                            }
                        </div>
                        <div className="col-md-4">
                            <label>City<span>*</span></label>
                            <input type="text" id="city" name="city" className="input-field-control"  onChange={this.inputchange} placeholder="City" value={formData.city} required/>
                            <span style={styleData} className="error">{formArr.city && validation.errors.first('city')}</span>
                            
                        </div>
                        <div className="col-md-4">
                            <label>Latitude<span>*</span></label>
                            <input type="text" id="latitude" name="latitude" className="input-field-control"  onChange={this.inputchange} placeholder="Latitude" value={formData.latitude} required/>
                            <span style={styleData} className="error">{formArr.latitude && validation.errors.first('latitude')}</span>
                        </div>
                        <div className="col-md-4">
                            <label>Longitude<span>*</span></label>
                            <input type="text" id="longitude" name="longitude" className="input-field-control"  onChange={this.inputchange} placeholder="Longitude" value={formData.longitude} required/>
                            <span style={styleData} className="error">{formArr.longitude && validation.errors.first('longitude')}</span>
                            
                        </div>
                        <div className="col-md-4">
                            <button className="button-clicks" onClick={this.addCityCountry}>Add City</button>
                        </div>

                     </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    console.log("state",state)
    return {
        cityCountryAdd:state.CountryStaeCity.responseCitysugg,
    };
}


export default withRouter(connect(mapStateToProps, {
    addAdminCityAction
})(AdminAddCity));


// WEBPACK FOOTER //
// ./src/components/Admin/City/AddCity.js